import classNames from "classnames";
const RailsCeiling = ({
  className,
  isActive,
}: {
  className?: string;
  isActive: boolean;
}) => (
  <svg
    height={70}
    viewBox="0 0 25 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, {
      "gg-fill-dark-blue": !isActive,
      "gg-fill-[#e5e5f1]": isActive,
    })}
  >
    <path
      d="M24 0a1 1 0 0 1 1 1v54a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h2z"
      // fill="#292747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8a1 1 0 0 0-1 1v23a1 1 0 1 0 2 0 1 1 0 0 1 1-1h14a1 1 0 0 1 1 1 1 1 0 1 0 2 0V9a1 1 0 0 0-1-1H1z"
      fill="#69687E"
    />
    <path
      d="M11.5 68V48a1.5 1.5 0 0 0-3 0v20a1.5 1.5 0 0 0 3 0z"
      fill="#BFBEC8"
      stroke="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 32a1 1 0 0 0-1 1 1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V35a1 1 0 0 0-1-1h-1a1 1 0 0 1-1-1 1 1 0 0 0-1-1H4z"
      fill="#9493A3"
    />
  </svg>
);
export default RailsCeiling;
